import { useMutation, useQueryClient } from "react-query";
import { useRecoilState } from "recoil";
import { updateDistributionChannel } from "../../../../../actions/Utilities/DistributionChannel";
import { toast } from "../../../../../components/toastNotification";
import { editStateDistributionChannel, editStateMGA } from "../atoms/atoms";

const useUpdateDistributionChannel = () => {
  const queryClient = useQueryClient();
  const [, setEditState] = useRecoilState(editStateDistributionChannel);

  const { mutate } = useMutation(
    (distChannel) => updateDistributionChannel({ ...distChannel }),
    {
      onSuccess: (res) => {
        if (res.data === "duplicate") {
          toast.fire(
            "Failed",
            "Another Distribution Channel already has the same information",
            "error"
          );
        } else if (res.status === 201) {
          setEditState(false);
          queryClient.invalidateQueries("GetDistributionChannelList");
          toast.fire(
            "Success",
            "Distribution Channel updated successfully",
            "success"
          );
        } else {
          toast.fire(
            "Failed",
            "Server Error: Cannot update Distribution Channel",
            "error"
          );
        }
      },
      onError: (error) => {
        if (
          error.response.data.message === "Failed sending of email" ||
          error.response.data.message === "Failed inserting of notification"
        ) {
          toast.fire(
            "Success",
            "Distribution Channel updated successfully, but " +
              error.response.data.message,
            "warning"
          );
          queryClient.invalidateQueries("GetDistributionChannelList");
        } else {
          toast.fire(
            "Failed",
            "Server Error: Cannot add new Distribution Channel",
            "error"
          );
        }
      },
    }
  );
  return mutate;
};
export default useUpdateDistributionChannel;
